import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { statusColorFromRiskScore } from '../common';
import { CaclSupplierRisk } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import {
  DataGridConfig,
  StatusChipCell,
  UseDataGridConfig,
  cellFactory,
  gridColDefFactory,
} from '~/components/DataGridCustom';
import { RiskCategoryCell } from '~/components/DataGridCustom/cells/RiskCategoryCell/RiskCategoryCell';

import { ButtonCell } from './ButtonCell';

export const useSupplierRisksGridConfig: UseDataGridConfig<CaclSupplierRisk> = () => {
  const { t } = useTranslation(I18nNamespace.riskSustainability);
  const { t: tColumn } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: 'SupplierRisksGrid.column' });

  return useMemo(() => {
    const createColumn = gridColDefFactory({ tColumn, t });
    return {
      columns: [
        createColumn({
          field: 'riskCategoryId',
          renderCell: cellFactory(RiskCategoryCell),
          minWidth: 100,
        }),
        createColumn({
          field: 'name',
          minWidth: 350,
        }),
        createColumn({
          field: 'description',
          minWidth: 500,
        }),
        createColumn({
          field: 'score',
          renderCell: cellFactory(StatusChipCell, ({ value }) => ({
            value: value ? t(`RiskScore.${value}`) : null,
            color: statusColorFromRiskScore(value),
          })),
          minWidth: 120,
        }),
        createColumn({
          field: 'action',
          renderCell: cellFactory(ButtonCell),
          minWidth: 150,
        }),
      ],
    } as DataGridConfig<CaclSupplierRisk>;
  }, [t, tColumn]);
};
